(function () {
  var STOREFRONT_TOKEN = 'b00f0665862682dee74b0c6889903a24';
  var SHOP_DOMAIN = 'shop.bioworldmerch.com';
  var API_VERSION = '2025-01';

  var style = document.createElement('style');
  style.textContent = '.sku-results__heading{margin-bottom:1rem;margin-top:0.5rem}';
  document.head.appendChild(style);

  // activeQuery tracks "q|page" so that paginating clears the cache and stops
  // re-injection of page-1 results onto page-2+ containers.
  var activeQuery = null;
  var cachedSkuProducts = null;
  var cachedTerms = null;

  function getParams() {
    var p = new URLSearchParams(window.location.search);
    return { terms: p.get('q'), page: parseInt(p.get('page') || '1') };
  }

  function queryKey(terms, page) {
    return terms + '|' + page;
  }

  function getContainer() {
    return document.querySelector('[data-ajax-container="products"]');
  }

  function getShownHandles(container) {
    return new Set(Array.from(container.querySelectorAll('product-block .product-link')).map(function (el) {
      return (el.getAttribute('href') || '').replace('/products/', '').split('?')[0];
    }));
  }

  // Returns true if at least one card with a matching SKU prefix is already in the container.
  // Used to detect when Shopify's AJAX wipes our injected results.
  function hasMatchingProducts(container, terms) {
    var upper = terms.toUpperCase();
    return Array.from(container.querySelectorAll('.product-block__sku')).some(function (el) {
      return el.textContent.replace(/^Sku:\s*/i, '').toUpperCase().startsWith(upper);
    });
  }

  function formatMoney(amount, currencyCode) {
    return '$' + parseFloat(amount).toFixed(2) + ' ' + currencyCode;
  }

  function buildCard(p) {
    var img = p.featuredImage
      ? '<img src="' + p.featuredImage.url + '&width=400" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">'
      : '';

    var sku = (p.variants && p.variants.edges && p.variants.edges[0])
      ? '<div class="product-block__sku">Sku: ' + p.variants.edges[0].node.sku + '</div>'
      : '';

    var price = (p.priceRange && p.priceRange.minVariantPrice)
      ? '<div class="product-block__price-row">'
        + '<div class="product-block__price">'
        + '<div class="product-price">'
        + '<span class="product-price__item product-price__amount theme-money">'
        + formatMoney(p.priceRange.minVariantPrice.amount, p.priceRange.minVariantPrice.currencyCode)
        + '</span>'
        + '</div></div></div>'
      : '';

    return '<product-block class="product-block">'
      + '<div class="block-inner card-scheme card-scheme--1">'
      + '<div class="block-inner-inner">'
      + '<div class="image-cont">'
      + '<a class="product-link" href="/products/' + p.handle + '" aria-label="' + p.title.replace(/"/g, '&quot;') + '" tabindex="-1">'
      + '<div class="image-label-wrap"><div class="image-label-wrap__images">'
      + '<div class="product-block__image product-block__image--primary product-block__image--active">'
      + img
      + '</div></div></div>'
      + '</a>'
      + '</div>'
      + '<div class="product-info">'
      + '<a class="product-link" href="/products/' + p.handle + '">'
      + '<div class="product-block__title">' + p.title + '</div>'
      + sku
      + '</a>'
      + price
      + '</div>'
      + '</div></div>'
      + '</product-block>';
  }

  function inject(skuProducts, terms) {
    var container = getContainer();
    if (!container) return;

    // Only remove mismatched native cards when the API found SKU results.
    // If skuProducts is empty the user typed a text term (e.g. "SPIDER") and native
    // results should be left completely alone.
    var removedCount = 0;
    if (skuProducts.length > 0) {
      var upperTerms = terms.toUpperCase();
      container.querySelectorAll('product-block').forEach(function (pb) {
        var skuEl = pb.querySelector('.product-block__sku');
        if (!skuEl) return;
        if (!skuEl.textContent.replace(/^Sku:\s*/i, '').toUpperCase().startsWith(upperTerms)) {
          pb.remove();
          removedCount++;
        }
      });
    }

    var shownHandles = getShownHandles(container);
    var fresh = skuProducts.filter(function (p) {
      return !shownHandles.has(p.handle);
    });

    // Nothing to do — native results are already correct, don't touch count or DOM
    if (fresh.length === 0 && removedCount === 0) return;

    var countEl = document.querySelector('[data-ajax-container="result-count"] .lighter-text');
    var standardList = container.querySelector('.product-list');
    var noResults = container.querySelector('.align-centre');

    if (standardList) {
      if (fresh.length) {
        standardList.insertAdjacentHTML('beforeend', fresh.map(buildCard).join(''));
      }
      if (countEl) {
        var total = container.querySelectorAll('product-block').length;
        countEl.textContent = 'We found ' + total + ' result' + (total === 1 ? '' : 's');
      }
    } else if (noResults) {
      if (!fresh.length) return;
      var el = document.createElement('div');
      el.className = 'sku-results';
      var grid = document.createElement('div');
      grid.className = 'product-list product-list--per-row-4 product-list--per-row-mob-2';
      grid.innerHTML = fresh.map(buildCard).join('');
      el.appendChild(grid);
      noResults.replaceWith(el);
      if (countEl) {
        countEl.textContent = 'We found ' + fresh.length + ' result' + (fresh.length === 1 ? '' : 's');
      }
    }
  }

  function run() {
    var p = getParams();
    var terms = p.terms;
    var page = p.page;
    var key = queryKey(terms, page);

    if (!terms) return;
    if (key === activeQuery) return;

    activeQuery = key;
    cachedSkuProducts = null;
    cachedTerms = null;

    // Only run SKU injection on page 1. On paginated pages leave native results alone --
    // the cache is already cleared above so the MO won't re-inject either.
    if (page > 1) return;

    fetch('https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: [
          'query SkuSearch($q: String!) {',
          '  search(query: $q, types: PRODUCT, first: 30) {',
          '    edges { node { ... on Product {',
          '      title handle',
          '      featuredImage { url }',
          '      priceRange { minVariantPrice { amount currencyCode } }',
          '      variants(first: 1) { edges { node { sku } } }',
          '    } } }',
          '  }',
          '}'
        ].join('\n'),
        variables: { q: 'variants.sku:' + terms + '*' }
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (activeQuery !== key) return; // newer query already started, discard
      var edges = ((data.data || {}).search || {}).edges || [];
      cachedSkuProducts = edges.map(function (e) { return e.node; });
      cachedTerms = terms;
      inject(cachedSkuProducts, terms);
    });
  }

  var container = getContainer();
  if (!container) return;

  new MutationObserver(function () {
    var p = getParams();
    var currentTerms = p.terms;
    var currentKey = queryKey(currentTerms, p.page);

    if (!currentTerms) return;

    if (currentKey !== activeQuery) {
      // Query or page changed -- run() will clear cache; won't fetch on page > 1
      run();
    } else if (cachedTerms === currentTerms && cachedSkuProducts && !hasMatchingProducts(getContainer(), currentTerms)) {
      // Same query, page 1 -- Shopify's AJAX wiped our injected cards. Re-inject from cache.
      inject(cachedSkuProducts, currentTerms);
    }
  }).observe(container, { childList: true });

  var _pushState = history.pushState.bind(history);
  history.pushState = function (state, title, url) {
    _pushState(state, title, url);
    run();
  };
  window.addEventListener('popstate', run);

  run();
})();
